import { $, $$, isMobile } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-news]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-news] [data-au-segmented-control]').forEach((el) => {
    el.addEventListener('click', filterSelection);
  });
  isMobile.addEventListener('change', () => {
    if (isMobile.matches) {
      newsMultiSearchBarSticky();
    }
  });

  if (isMobile.matches) {
    newsMultiSearchBarSticky();
  }
}

function filterSelection(e) {
  const trigger = e.currentTarget;
  const triggerId = trigger.dataset.auSegmentedControl;
  const target = $(`[data-au-news-block="${triggerId}"]`);
  const titleText = trigger.closest('[data-au-news]').querySelector('[data-au-title]')
    ? trigger.closest('[data-au-news]').querySelector('[data-au-title]').innerText
    : '';
  const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(triggerId)}`;

  e.currentTarget
    .closest('[data-au-news]')
    .querySelectorAll('[data-au-news-block]')
    .forEach((formBlock) => {
      formBlock.classList.add('au-hide');
      formBlock.classList.remove('au-active');
    });

  target.classList.add('au-active');
  target.classList.remove('au-hide');

  // datalayer
  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickTab',
    item_id,
  });
}

/**
 *  Function to set sticky position of multisearchbar and show it or hide it
 * depending on scroll up or down
 */
function newsMultiSearchBarSticky() {
  let lastScrollTop = 0;
  const multiSearchBars = $$('[data-au-news-multisearch-bar]');
  const headerHeight = $('header > div') ? $('header > div').offsetHeight + 8 : 54;

  multiSearchBars.forEach((multiSearchBar) => {
    // set sticky top position of multisearch bar
    multiSearchBar.style.top = `${headerHeight}px`;
  });

  // show or hide multisearchbar when scroll down and if scrolltop is higher than offset top of multisearch bar
  window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    multiSearchBars.forEach((multiSearchBar) => {
      const multiSearchBarTop = parseInt(multiSearchBar.getBoundingClientRect().top + window.scrollY, 10);

      if (scrollTop > lastScrollTop && scrollTop >= multiSearchBarTop - headerHeight) {
        // Scroll down
        multiSearchBar.classList.add('au-news__multisearch--hide');
      } else {
        // Scroll up
        multiSearchBar.classList.remove('au-news__multisearch--hide');
      }
    });

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // To avoid negative values on iOS
  });
}

export default { init };
